/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Registration_Info_Link_TextInputs */

const en_company_registration_info_link_text = /** @type {(inputs: Company_Registration_Info_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Information about the Matching Week process can be found at`)
};

const de_company_registration_info_link_text = /** @type {(inputs: Company_Registration_Info_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informationen zum Ablauf der Matching Week finden Sie unter`)
};

/**
* | output |
* | --- |
* | "Information about the Matching Week process can be found at" |
*
* @param {Company_Registration_Info_Link_TextInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_registration_info_link_text = /** @type {((inputs?: Company_Registration_Info_Link_TextInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Registration_Info_Link_TextInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_registration_info_link_text(inputs)
	return en_company_registration_info_link_text(inputs)
});